import { DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE } from "@/redux/reducers/dashboard";
import type { DashboardReduxReducerActions } from "@/redux/reducers/dashboard";

export const dashboardReduxReducerActions: DashboardReduxReducerActions = {
  setLastUrlWasPage(url) {
    return {
      payload: url,
      type: DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_LAST_URL_WAS_PAGE,
    };
  },
  setPayOrderStep(step) {
    return {
      payload: step,
      type: DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_PAY_ORDER_STEP,
    };
  },
  setRetryGetOrder(step) {
    return {
      payload: step,
      type: DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_RETRY_GET_ORDER,
    };
  },
  setCloseGetOrderOpenInMobileModal() {
    return {
      payload: false,
      type: DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_CLOSE_GET_ORDER_OPEN_IN_MOBILE_MODAL,
    };
  },
  setOpenGetOrderOpenInMobileModal() {
    return {
      payload: true,
      type: DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_OPEN_GET_ORDER_OPEN_IN_MOBILE_MODAL,
    };
  },
  setCloseGetOrderOpenInSupportedDevices() {
    return {
      payload: false,
      type: DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_CLOSE_GET_ORDER_OPEN_IN_SUPPORTED_DEVICES_MODAL,
    };
  },
  setOpenGetOrderOpenInSupportedDevices() {
    return {
      payload: true,
      type: DASHBOARD_REDUX_REDUCER_ACTIONS_TYPE.SET_OPEN_GET_ORDER_OPEN_IN_SUPPORTED_DEVICES_MODAL,
    };
  },
};
